import { getVideo } from './getVideo';
import { stickyHeader } from './stickyHeader';

import {Keycode} from '../../constants';

const OPEN_NAV_MENU_CLASS = 'open-burger';
const OPEN_SEARCH_CLASS = 'open-search';

const initHeader = () => {
	const header = document.querySelector( 'header' );

	if ( !header )
	{
		return;
	}

	stickyHeader( header );
	
	const burger = header.querySelector( 'div.burger' );

	burger.classList.remove( 'not-init' );


	header.addEventListener( 'click', ( evt ) => {
		const target = evt.target;

		if ( header.classList.contains( 'open-search' ) && !target.closest( 'div.search-wrapper' ) && !target.closest( 'div.search' ) )
		{
			header.classList.toggle( OPEN_SEARCH_CLASS );
			document.querySelector( 'html' ).classList.remove( 'search' );

			return;
		}

		if ( target.closest( 'button.toggle-burger' ) || target.closest( 'button.toggle-dots' ) )
		{
			header.classList.toggle( OPEN_NAV_MENU_CLASS );
		}

		if ( target.closest( 'button.search' ) )
		{
			getVideo( header );

			header.classList.toggle( OPEN_SEARCH_CLASS );
			document.querySelector( 'html' ).classList.toggle( 'search' );
		}
	} );

	header.addEventListener( 'keyup', ( evt ) => {
		if ( evt.keyCode === Keycode.ESC )
		{
			header.classList.remove( OPEN_NAV_MENU_CLASS );
			header.classList.remove( OPEN_SEARCH_CLASS );
			document.querySelector( 'html' ).classList.remove( 'search' );
		}
	} );

	document.addEventListener( 'click', ( evt ) => {
		const target = evt.target;

		if ( !target.closest( 'div.burger' ) && header.classList.contains( OPEN_NAV_MENU_CLASS ) && !target.closest( 'button.toggle-burger' ) && !target.closest( 'button.toggle-dots' ) && !target.closest( 'button.to-top' ) )
		{
			header.classList.remove( OPEN_NAV_MENU_CLASS );
		}

		if ( !target.closest( 'div.search-wrapper' ) && !target.closest( 'div.search' ) && header.classList.contains( OPEN_SEARCH_CLASS ) && !target.closest( 'button.search' ) && !target.closest( 'button.toggle-dots' ) && !target.closest( 'button.to-top' ) )
		{
			header.classList.remove( OPEN_SEARCH_CLASS );
			document.querySelector( 'html' ).classList.remove( 'search' );
		}
	} );
};

export {
	initHeader,
};
